import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export function ProtectedUserRoute() {
  const { user } = useContext(AuthContext);
  return user ? <Outlet /> : <Navigate to="/login" replace />;
}

export function PublicOnlyUserRoute() {
  const { user } = useContext(AuthContext);
  return user ? <Navigate to="/" replace /> : <Outlet />;
}

export function ProtectedAdminRoute() {
  const { admin } = useContext(AuthContext);
  return admin ? <Outlet /> : <Navigate to="/admin" replace />;
}
